// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_EventReprocessResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_EventReprocessResponse — result of
 * POST /subscriptions/admin/events/{id}/reprocess (S9 / M5).
 *
 * new_status is nullable: reprocessEvent() can succeed via a no_op dispatch
 * branch (e.g. an already-cancelled subscription, or an unhandled event_type)
 * that never assigns a 'new_status' key — this field stays honest (null)
 * rather than guessing, same anti-lying discipline as
 * SubscriptionConfirmationService::resolvePeriodWindow() (S4.2).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_EventReprocessResponseDados {
event_id: string
event_type: string
new_status: string
}

export type Subscriptions_EventReprocessResponse = ApiResponse<Subscriptions_EventReprocessResponseDados>;

registerResponseContract('Subscriptions_EventReprocessResponse', {
  event_id:   { type: 'string',  required: true },
  event_type: { type: 'string',  required: true },
  new_status: { type: 'string',  required: false },
})
